(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bss-slider')) {
  class BssSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bss-track]');
      const prevBtn = this.querySelector('[data-bss-prev]');
      const nextBtn = this.querySelector('[data-bss-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.scrollByCard(1));
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.bss__card-slide');
      if (!card) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      const amount = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: amount, behavior: 'smooth' });
    }
  }
  customElements.define('bss-slider', BssSlider);
}

if (!window.__bssCardsBound) {
  window.__bssCardsBound = true;

  const bssSelectSwatch = function (swatch) {
    const card = swatch.closest('[data-bss-card]');
    if (!card) return;

    card.querySelectorAll('[data-bss-swatch]').forEach(function (el) {
      el.setAttribute('aria-checked', el === swatch ? 'true' : 'false');
    });

    const input = card.querySelector('[data-bss-variant-input]');
    if (input) input.value = swatch.dataset.variantId;

    const price = card.querySelector('[data-bss-price]');
    if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;

    const image = card.querySelector('.bss__image');
    if (image && swatch.dataset.image) {
      image.removeAttribute('srcset');
      image.src = swatch.dataset.image;
    }

    const cta = card.querySelector('[data-bss-cta]');
    if (cta) {
      const available = swatch.dataset.available === 'true';
      cta.disabled = !available;
      cta.classList.remove('is-added');
      cta.textContent = available ? cta.dataset.labelDefault : 'Sold out';
    }
  };

  const bssRefreshCount = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        const bubble = document.querySelector('.cart-count-bubble');
        if (bubble) {
          const span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
          if (span) span.textContent = cart.item_count;
        }
      })
      .catch(function () {});
  };

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('[data-bss-swatch]');
    if (!swatch) return;
    event.preventDefault();
    bssSelectSwatch(swatch);
  });

  document.addEventListener('keydown', function (event) {
    const swatch = event.target.closest('[data-bss-swatch]');
    if (!swatch) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const group = Array.prototype.slice.call(swatch.parentElement.querySelectorAll('[data-bss-swatch]'));
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = group[(group.indexOf(swatch) + step + group.length) % group.length];
    next.focus();
    bssSelectSwatch(next);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-bss-form]');
    if (!form) return;
    const cta = form.querySelector('[data-bss-cta]');
    const input = form.querySelector('[data-bss-variant-input]');
    if (!cta || !input) return;

    event.preventDefault();
    const label = cta.dataset.labelDefault;
    cta.disabled = true;
    cta.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        cta.textContent = 'Added';
        cta.classList.add('is-added');
        bssRefreshCount();
        setTimeout(function () {
          cta.classList.remove('is-added');
          cta.textContent = label;
          cta.disabled = false;
        }, 1800);
      })
      .catch(function () {
        cta.textContent = label;
        cta.disabled = false;
      });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-shade"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbs-shop-by-shade')) {
  class SbsShopByShade extends HTMLElement {
    connectedCallback() {
      this.swatchButtons = Array.from(this.querySelectorAll('[data-sbs-swatch]'));
      this.panels = Array.from(this.querySelectorAll('[data-sbs-panel]'));
      this.cta = this.querySelector('[data-sbs-cta]');
      this.prevBtn = this.querySelector('[data-sbs-prev]');
      this.nextBtn = this.querySelector('[data-sbs-next]');

      this.swatchButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.activateSwatch(btn));
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollActivePanel(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollActivePanel(1));

      this.addEventListener('click', (event) => {
        const variantSwatch = event.target.closest('[data-sbs-variant-swatch]');
        if (variantSwatch) {
          event.preventDefault();
          this.selectVariant(variantSwatch);
          return;
        }
        const addBtn = event.target.closest('[data-sbs-add]');
        if (addBtn) this.addToCart(addBtn);
      });

      this.addEventListener('keydown', (event) => {
        const swatch = event.target.closest('[data-sbs-variant-swatch]');
        if (!swatch) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const group = Array.from(swatch.parentElement.querySelectorAll('[data-sbs-variant-swatch]'));
        const step = event.key === 'ArrowRight' ? 1 : -1;
        const next = group[(group.indexOf(swatch) + step + group.length) % group.length];
        next.focus();
        this.selectVariant(next);
      });
    }

    selectVariant(swatch) {
      const card = swatch.closest('[data-sbs-card]');
      if (!card) return;

      card.querySelectorAll('[data-sbs-variant-swatch]').forEach((el) => {
        el.setAttribute('aria-checked', el === swatch ? 'true' : 'false');
      });

      const price = card.querySelector('[data-sbs-price]');
      if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;

      const image = card.querySelector('.sbs__image');
      if (image && swatch.dataset.image) {
        image.removeAttribute('srcset');
        image.src = swatch.dataset.image;
      }

      const addBtn = card.querySelector('[data-sbs-add]');
      if (addBtn) {
        const available = swatch.dataset.available === 'true';
        addBtn.setAttribute('data-variant-id', swatch.dataset.variantId);
        addBtn.disabled = !available;
        addBtn.title = available ? 'Add to cart' : 'Sold out';
      }
    }

    activateSwatch(button) {
      this.swatchButtons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      const targetId = button.getAttribute('data-target');
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-hidden', panel.id !== targetId);
      });

      const collectionUrl = button.getAttribute('data-collection-url');
      if (this.cta && collectionUrl) this.cta.setAttribute('href', collectionUrl);
    }

    getActivePanel() {
      return this.panels.find((panel) => !panel.classList.contains('is-hidden'));
    }

    scrollActivePanel(direction) {
      const panel = this.getActivePanel();
      if (!panel) return;
      const card = panel.querySelector('.sbs__card-slide');
      if (!card) return;
      const style = getComputedStyle(panel);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      const amount = (card.getBoundingClientRect().width + gap) * direction;
      panel.scrollBy({ left: amount, behavior: 'smooth' });
    }

    addToCart(button) {
      if (button.classList.contains('is-loading') || button.disabled) return;
      button.classList.add('is-loading');
      const variantId = button.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then((response) => {
          if (!response.ok) throw new Error('add_failed');
          return response.json();
        })
        .then(() => {
          const plusIcon = button.querySelector('[data-icon-plus]');
          const checkIcon = button.querySelector('[data-icon-check]');
          button.classList.add('is-added');
          if (plusIcon) plusIcon.hidden = true;
          if (checkIcon) checkIcon.hidden = false;
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((res) => (res.ok ? res.json() : null))
            .then((cart) => {
              if (!cart) return;
              const bubble = document.querySelector('.cart-count-bubble');
              if (!bubble) return;
              const span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
              if (span) span.textContent = cart.item_count;
            })
            .catch(() => {});
          setTimeout(() => {
            button.classList.remove('is-added');
            if (plusIcon) plusIcon.hidden = false;
            if (checkIcon) checkIcon.hidden = true;
          }, 1800);
        })
        .catch(() => {})
        .finally(() => {
          button.classList.remove('is-loading');
        });
    }
  }
  customElements.define('sbs-shop-by-shade', SbsShopByShade);
}

  } catch(e) { console.error(e); }
})();
})();
